import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type ReorderQuoteRequestLinesResponse = ClientInferResponseBody<
  typeof contract.quoteRequestLines.reorder,
  200
>;

export const reorderQuoteRequestLines = async ({
  quoteRequestId,
  orderedIds,
}: {
  quoteRequestId: string;
  orderedIds: string[];
}): Promise<ReorderQuoteRequestLinesResponse> => {
  const response = await api.quoteRequestLines.reorder.mutation({
    body: {
      quoteRequestId,
      orderedIds,
    },
  });

  if (response.status !== 200) {
    throw new ApiError("Error reordering quote request lines", response.status, response.body);
  }

  return response.body;
};
